import Alooma from 'services/alooma';
import { useCardRetailerSquareBreakpoints } from 'hooks/grid/useCardRetailerSquareBreakpoint';
import BaseSwiperSlider from 'components/organisms/BaseSwiperSlider/BaseSwiperSlider';
import CardRetailerSquare from 'components/molecules/CardRetailerSquare/CardRetailerSquare';

const RetailersSlider = ({ retailers }) => {
  const breakpoints = useCardRetailerSquareBreakpoints();

  return (
    <BaseSwiperSlider breakpoints={breakpoints} v2>
      {retailers.map(retailer => (
        <div key={retailer.self_id}>
          <Alooma.RetailerIdContext.Provider value={retailer.self_id}>
            <CardRetailerSquare retailer={retailer} />
          </Alooma.RetailerIdContext.Provider>
        </div>
      ))}
    </BaseSwiperSlider>
  );
};

export default RetailersSlider;
